/**
 * Helper function to get environment variable from runtime config or build-time env
 * Prioritizes runtime config (window.env) over build-time environment variables
 */
export const getEnvVar = (key: string): string => {
  // First try runtime config (window.env), then fall back to build-time env
  const runtimeValue = (window as any)?.env?.[key];
  const buildValue = import.meta.env[key];
  const value = runtimeValue || buildValue;
  
  if (!value) {
    throw new Error(`${key} environment variable is required`);
  }
  return value;
};

/**
 * Helper function to get environment variable with a default fallback
 */
export const getEnvVarWithDefault = (key: string, defaultValue: string): string => {
  const runtimeValue = (window as any)?.env?.[key];
  const buildValue = import.meta.env[key];
  return runtimeValue || buildValue || defaultValue;
};